import React, { useEffect, useState } from "react";
import { Button, Modal, Table, Typography } from "antd";
import ButtonRow from "components/common/ButtonRow";
import {
  RopeFlagCommercialReviewEmailSend,
  RopeLandingPageData,
  RopeMessage
} from "types/Rope";
import { getRopeUploadMessages, importRope } from "api/ropeApi";
import displayErrorNotification from "utils/displayErrorNotification";
import { ColumnProps } from "antd/lib/table";
import formatDate from "utils/formatDate";
import {
  convertRopeLandingsPageDataToImportDto,
  convertRopeMessageData
} from "utils/convert";
import { textOverflow } from "components/common/textOverflow";

type RopeImportConfirmModalProps = {
  modalState: boolean;
  closeModal: () => void;
  refresh: () => void;
  record: RopeLandingPageData | null;
};

const RopeImportConfirmModal = (props: RopeImportConfirmModalProps) => {
  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState<RopeMessage[] | null>(null);

  useEffect(() => {
    if (props.record) {
      setLoading(true);
      getRopeUploadMessages(props.record.uploadId)
        .then(data => {
          const converted = convertRopeMessageData(data);
          setMessages(converted);
        })
        .catch(displayErrorNotification)
        .then(() => {
          setLoading(false);
        });
    }
  }, []);

  const continueClicked = () => {
    setLoading(true);
    importRope(convertRopeLandingsPageDataToImportDto(props.record))
      .then(response => {
        console.log(response);
      })
      .catch(displayErrorNotification)
      .finally(() => {
        props.refresh();
        setLoading(false);
        props.closeModal();
      });
  };

  let columns: ColumnProps<RopeMessage>[] = [
    {
      title: "Level",
      dataIndex: "level",
      width: "60px"
    },
    {
      title: "Message",
      dataIndex: "message",
      render: message => textOverflow(message, 200)
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "60px"
    }
  ];

  if (props && props.record) {
    return (
      <Modal
        title={"Do you want to proceed?"}
        visible={props.modalState}
        onCancel={props.closeModal}
        footer={null}
        width={"1500px"}
        maskClosable={!loading}
        closable={!loading}
      >
        <Typography.Paragraph>
          <strong>Project:</strong>{" "}
          {(props.record.projectCode ? props.record.projectCode : "") +
            " [" +
            props.record.projectName +
            "] " +
            formatDate(props.record.startDate)}
        </Typography.Paragraph>
        <Table
          pagination={{ pageSize: 8, position: "top", hideOnSinglePage: true }}
          rowKey="level"
          columns={columns}
          dataSource={messages || []}
          loading={loading}
          scroll={{ x: "max-content" }}
        />
        <Typography.Paragraph
          style={{
            marginTop: "20px",
            marginBottom: "20px"
          }}
        >
          {props.record.flags.includes(RopeFlagCommercialReviewEmailSend) ? (
            <p>
              <strong>
                Make sure you have an approval from the Commercial Review Board
                before proceeding.
              </strong>
            </p>
          ) : (
            ""
          )}
          Please click "Import" to upload version{" "}
          <strong>
            {props.record.uploadVersion ? props.record.uploadVersion : ""}
          </strong>{" "}
          to{" "}
          <strong>
            {props.record.entity === "TA Digital" ? (
              <>Microsoft Dynamics 365 CRM</>
            ) : (
              <>Projector PSA</>
            )}
          </strong>
          . Once the spreadsheet is imported it can not be undone and the record
          will be marked as imported. Future upload or import will not be possible.
          This action will run in the background and you will be able to monitor
          completion by refreshing this page.
        </Typography.Paragraph>

        <ButtonRow style={{ marginTop: "1em" }}>
          <Button type="primary" loading={loading} onClick={continueClicked}>
            Import
          </Button>
          <Button loading={loading} onClick={props.closeModal}>
            Cancel
          </Button>
        </ButtonRow>
      </Modal>
    );
  } else {
    return <Modal />;
  }
};

export default RopeImportConfirmModal;
